import { useEffect } from 'react';
import { useTransaction } from '../../../context/TransactionContext';
import { TransactionTypeUsage } from '../../../constants/transaction';
import { InvoiceableType as MatterInvoiceableType } from '../../../constants/matter';
import { ITransaction } from '../../../interface/transaction';

export const useTransactionTypeValidation = () => {
  const { transaction, updateTransaction } = useTransaction();

  useEffect(() => {
    if (!transaction?.matter) return;

    const transactionType = transaction?.transactionType?.transactionTypeUsage;
    const matterType = transaction?.matter?.invoiceableType;

    const isBillableMismatch =
      transactionType === TransactionTypeUsage.billableMatter &&
      matterType !== MatterInvoiceableType.billable;
    const isNonBillableMismatch =
      transactionType === TransactionTypeUsage.billableMatter &&
      matterType === MatterInvoiceableType.nonBillable;
    const isInternalMismatch =
      transactionType === TransactionTypeUsage.internalMatter &&
      matterType !== MatterInvoiceableType.internal;

    if (
      transactionType &&
      matterType &&
      !isNonBillableMismatch &&
      (isBillableMismatch || isInternalMismatch)
    ) {
      updateTransaction({
        ...transaction,
        transactionType: null,
      } as unknown as ITransaction);
    }
  }, [transaction?.matter, transaction?.transactionType?.transactionTypeUsage, updateTransaction]);

  return {};
};
